import { useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useTranslation } from 'react-i18next';
import { DEVICE_LABEL_KEYS } from '../pages/MePagePage/components/LinkClicksTab/constants';

const EMPTY_VALUE = '—';

const formatDate = (date, locale) =>
  new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  }).format(new Date(date));

const useLinkClicksCsvDownload = (links) => {
  const { t, i18n } = useTranslation();
  const ref = useRef(null);
  const [csvData, setCsvData] = useState([]);

  const downloadCsv = () => {
    const data = links.map((link) => ({
      [t('linkClicks.linkNameUrl')]:
        [link.label, link.url].filter(Boolean).join('\n') || EMPTY_VALUE,
      [t('linkClicks.page')]: link.pageTitle ?? EMPTY_VALUE,
      [t('linkClicks.totalClicks')]: link.totalClicks,
      [t('linkClicks.uniqueClicks')]: link.uniqueClicks,
      [t('linkClicks.ctr')]:
        link.ctr === null ? EMPTY_VALUE : `${link.ctr.toFixed(1)}%`,
      [t('linkClicks.topCountry')]: link.topCountry ?? EMPTY_VALUE,
      [t('linkClicks.topDevice')]: DEVICE_LABEL_KEYS[link.topDevice]
        ? t(DEVICE_LABEL_KEYS[link.topDevice])
        : EMPTY_VALUE,
      [t('linkClicks.lastClick')]: link.lastClickAt
        ? formatDate(link.lastClickAt, i18n.language)
        : EMPTY_VALUE
    }));

    setCsvData(data);
  };

  useEffect(() => {
    if (csvData.length) {
      ref.current.link.click();
      setCsvData([]);
    }
  }, [csvData]);

  const CsvLinkHidden = () => (
    <CSVLink
      data={csvData}
      ref={ref}
      filename="link-clicks-statistics.csv"
      style={{ display: 'none' }}
    />
  );

  return { downloadCsv, isExportAvailable: links.length > 0, CsvLinkHidden };
};

export default useLinkClicksCsvDownload;
